const UseFormStateUtils = require('hooks/useFormPrimitives/state');

exports.MAX_BIO = 160;
exports.MAX_CAREER = 255;
exports.MAX_PRONOUNS_LENGTH = 30;
exports.MAX_ETHNICITY_LENGTH = 150;
exports.MAX_FIRST_AND_LAST_NAME_LENGTH = 30;

exports.MB_IN_BYTES = 1000000;

exports.UI_STATE_FIELDS = [
    ...UseFormStateUtils.FORM_UI_STATE_FIELDS,
    'uploadingProfilePic',
    'convertingProfilePic'
];
